/* unplugin-vue-components disabled */import { render } from "./weinan.vue?vue&type=template&id=6fdb903a&scoped=true"
import script from "./weinan.vue?vue&type=script&lang=js"
export * from "./weinan.vue?vue&type=script&lang=js"

import "./weinan.vue?vue&type=style&index=0&id=6fdb903a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdb903a"]])

export default __exports__